import { BPRIdDetails } from "../services/schedules-service";
import { BaseModel } from "./base-model";
import { BprAPIResponse } from "./types/voyage-best-practice-routes-impl.types";
import { VoyagePlan } from "./vessel-planning-model";
import { BestPracticeRouteStatus } from "./voyage-best-practice-routes-model-impl";
import { VoyageRoute } from "./voyage-routing-model";

export abstract class VoyageBestPracticeRoutesModelBase extends BaseModel
{
  abstract getAutoRoute(plan: VoyagePlan):  Promise<VoyageRoute | null>;
  abstract ifRouteShouldBeFetched(status: boolean, sceduleId?: string): void;
  abstract getBestPracticeRouteExistence(sceduleId: string): BestPracticeRouteStatus | null;
  abstract getBPRAvaliabilityPerSchedule(sceduleId: string, departurePortCall: string, arrivalPortCall: string): BPRIdDetails | null;
  abstract getRankedBPRsForSchedule(plan: VoyagePlan, triggerBprJob?: boolean): Promise<void>;
  abstract refreshStarRoutesForAcceptedVoyageDetails(plan: VoyagePlan, inputsChanged: boolean): Promise<void>;
  abstract getBPRsByScheduleId(scheduleId: string): VoyageRoute[];
  abstract getDeletedByScheduleId(scheduleId: string): string[];
  abstract requestAnotherStarRoute(scheduleId: string,optimizedBPRs: BprAPIResponse[] | null, noOfStarRoutesInPlan: number):  Promise<void>;
  abstract updateDeletedStarRoute(scheduleId: string, bprId: string, reset: boolean): void ;
  abstract hasPendingBPRJob(scheduleId: string): boolean;
  abstract isOpenOceanRouteEnabled(): boolean;
  abstract requestAnotherOpenOceanRoute(scheduleId: string, optimizedOORs: BprAPIResponse[], noOfOORsInPlan: number): Promise<void>;
  abstract updateDeletedOOR(scheduleId: string, oorId: string, reset: boolean): void;
  abstract getDeletedOORByScheduleId(scheduleId: string): string[];
}

let VoyageBestPracticeRoutesModel: VoyageBestPracticeRoutesModelBase|null = null;

function setVoyageBestPracticeRoutesModel(model: VoyageBestPracticeRoutesModelBase)
{
  VoyageBestPracticeRoutesModel = model;
}

export { VoyageBestPracticeRoutesModel, setVoyageBestPracticeRoutesModel };
